import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  compose,
  lifecycle,
  setPropTypes,
  withHandlers,
  withState
} from 'recompose';
import { bindActionCreators } from 'redux';
import {
  Drawer,
  MenuItem,
  // InputLabel,
  Paper,
  TextField,
  Typography
} from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import moment from 'moment';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import ListBookingTable from '../organisms/ListBookingTable';
import SearchButton from '../../components/atoms/SearchButton';
import { getAccounts } from '../../actions/Accounts';
import AcceptPopup from '../../components/molecules/AcceptPopup';

import {
  downloadBookings,
  getBookings,
  DOWNLOAD_BOOKING_SUCCESS,
  GET_BOOKING_SUCCESS
} from '../../actions/Booking';

import ConfirmDialog from '../../components/molecules/ConfirmDialog';
import { getSystems } from '../../actions/Systems';
import CsvDownloadButton from '../../components/atoms/CsvDownloadButton';

const re = /^[0-9\b]+$/;
const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textField150: {
    padding: '0px 5px 0px 5px',
    width: '200px'
  },
  button: {
    margin: '5px 5px'
  },
  buttonLeft: {
    textAlign: 'left'
  },
  buttonGroupLeft: {
    textAlign: 'left',
    float: 'left'
  },
  inputLabel: {
    fontSize: 12,
    width: '100%'
  },
  boxMargin: {
    marginTop: 16,
    marginBottom: 8,
    width: '300px',
    minWidth: 300
  },
  buttonGroupRight: {
    textAlign: 'right'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      systems: state.systems.list
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getAccounts,
          getBookings,
          // updateTicketsStatus,
          getSystems,
          downloadBookings
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('gochiBillNo', 'setGochiBillNo', null),
  withState('bookingId', 'setBookingId', null),
  withState('bookingUserName', 'setBookingUserName', null),
  withState('phoneNumber', 'setPhoneNumber', null),
  withState('shopId', 'setShopId', null),
  withState('groupName', 'setGroupName', null),
  withState('shopName', 'setShopName', null),
  withState('bookingTimeFrom', 'setBookingTimeFrom', null),
  withState('bookingTimeTo', 'setBookingTimeTo', null),
  withState('selectedBookingIds', 'setSelectedBookingIds', []),
  withState('page', 'setPage', 1),
  withState('openTable', 'updateOpenTable', false),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('bookingStatus', 'setBookingStatus', null),
  withState('loading', 'updateLoading', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('updateOpenAcceptPopup', 'setUpdateOpenAcceptPopup', ''),
  withState('openAcceptPopup', 'setOpenAcceptPopup', ''),
  withState('openConfirmDialog', 'setOpenConfirmDialog', false),
  withState('errorMessage', 'setErrorMessage', ''),
  withState('downloadParams', 'setDownloadParams', {}),
  withState('checked', 'setChecked', () => {
    return new Set();
  }),
  withHandlers({
    checkSession: props => data => {
      if (
        data.error === true &&
        typeof data.payload !== 'undefined' &&
        data.payload.status === 403
      ) {
        sendLogin(props);
      }
      return data;
    }
  }),
  withHandlers({
    csvDownloadAction: props => async () => {
      props.updateLoading(true);
      props.updateOpenProgress(true);
      const response = await props.actions
        .downloadBookings(props.downloadParams)
        .then(data => props.checkSession(data));
      if (response.type === DOWNLOAD_BOOKING_SUCCESS) {
        const timeStamp = moment()
          .tz('Asia/Tokyo')
          .format('YYYYMMDDHHmm');
        props.updateOpenProgress(false);
        props.setResultMessage('');
        props.updateLoading(false);
        const blob = response.payload;
        const fileName = `${timeStamp}_booking_info.csv`;

        if (window.navigator.msSaveOrOpenBlob) {
          // for IE,Edge
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          // for chrome, firefox
          const url = URL.createObjectURL(
            new Blob([blob], { type: 'text/csv' })
          );
          const linkEl = document.createElement('a');
          linkEl.href = url;
          linkEl.setAttribute('download', fileName);
          document.body.appendChild(linkEl);
          linkEl.click();

          linkEl.parentNode.removeChild(linkEl);
          setTimeout(() => {
            URL.revokeObjectURL(url);
          }, 1000);
        }
      } else {
        props.setResultMessage('データエクスポートに失敗しました。');
        props.updateLoading(false);
      }
    }
  }),
  withHandlers({
    handleChangePage: props => (event, page, limit) => {
      const limitNum = limit || props.rowsPerPage;
      console.log('HANDLE CHANGE PAGE');
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const searchKey = {
        gochiBillNo: props.gochiBillNo,
        bookingId: props.bookingId,
        status: props.bookingStatus,
        bookingUsername: props.bookingUserName,
        phoneNumber: props.phoneNumber,
        shopId: props.shopId,
        groupName: props.groupName,
        shopName: props.shopName,
        bookingTimeFrom: props.bookingTimeFrom,
        bookingTimeTo: props.bookingTimeTo,
        page,
        limit: limitNum
      };

      props.setDownloadParams(searchKey);

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions.getBookings(searchKey).then(data => {
        props.checkSession(data);
        console.log(data);
        if (data.type === GET_BOOKING_SUCCESS) {
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          props.updateOpenTable(true);
        } else {
          props.setErrorMessage('エラーが発生しました！');
          props.updateLoading(false);
          props.updateOpenProgress(false);
        }
      });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
        this.props.actions.getSystems();
        this.props.handleChangePage(null, 1, this.props.rowsPerPage);
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    openDrawer,
    updateOpenDrawer,
    account,
    openTable,
    updateOpenTable,
    openProgress,
    updateOpenProgress,
    page,
    handleChangePage,
    loading,
    updateLoading,
    rowsPerPage,
    setRowsPerPage,
    resultMessage,
    setResultMessage,
    gochiBillNo,
    setGochiBillNo,
    bookingId,
    bookingStatus,
    setBookingStatus,
    setBookingId,
    bookingUserName,
    setBookingUserName,
    phoneNumber,
    setPhoneNumber,
    bookingTimeTo,
    setBookingTimeTo,
    selectedTicketIds,
    bookingTimeFrom,
    setBookingTimeFrom,
    openAcceptPopup,
    setOpenAcceptPopup,
    setUpdateOpenAcceptPopup,
    selectedBookingIds,
    setSelectedBookingIds,
    openConfirmDialog,
    setOpenConfirmDialog,
    shopId,
    setShopId,
    groupName,
    setGroupName,
    shopName,
    setShopName,
    checked,
    setChecked,
    errorMessage,
    setErrorMessage,
    csvDownloadAction
  }) => {
    const searchAction = async () => {
      updateOpenTable(true);
      handleChangePage(null, 1, rowsPerPage);
    };

    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress,
      setResultMessage
    };

    const onChangeBookingStatus = ids => {
      setSelectedBookingIds(ids);
      setOpenAcceptPopup(true);
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
      updateLoading(true);
      handleChangePage(null, page, rowsPerPage);
    };
    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            お客様からの連絡
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.searchForm}>
            <div>
              <TextField
                label="領収書No"
                type="search"
                className={classes.textField}
                margin="normal"
                value={gochiBillNo}
                onChange={e => {
                  setGochiBillNo(e.target.value);
                }}
              />
              <TextField
                label="連絡番号"
                type="text"
                className={classes.textField}
                margin="normal"
                value={bookingId}
                onChange={e => {
                  if (e.target.value === '' || re.test(e.target.value)) {
                    setBookingId(e.target.value);
                  }
                }}
              />
              <TextField
                select
                label="連絡状況"
                className={classes.textField}
                margin="normal"
                value={bookingStatus}
                onChange={e => {
                  setBookingStatus(e.target.value || '');
                }}
                InputLabelProps={{
                  shrink: bookingStatus !== ''
                }}
              >
                <MenuItem id="">選択なし</MenuItem>
                <MenuItem key="0" value="WAITING">
                  進行中
                </MenuItem>
                <MenuItem key="1" value="FINISHED">
                  完了
                </MenuItem>
              </TextField>
              <TextField
                label="連絡者名"
                type="search"
                className={classes.textField}
                margin="normal"
                value={bookingUserName}
                onChange={e => {
                  setBookingUserName(e.target.value);
                }}
              />
              <TextField
                label="電話番号"
                type="search"
                className={classes.textField}
                margin="normal"
                value={phoneNumber}
                onChange={e => {
                  setPhoneNumber(e.target.value);
                }}
              />
              <TextField
                label="店舗ID"
                type="text"
                className={classes.textField}
                margin="normal"
                value={shopId}
                onChange={e => {
                  if (e.target.value === '' || re.test(e.target.value)) {
                    setShopId(e.target.value);
                  }
                }}
              />
              <TextField
                label="グループ名"
                type="search"
                className={classes.textField}
                margin="normal"
                value={groupName}
                onChange={e => {
                  setGroupName(e.target.value);
                }}
              />
              <TextField
                label="店舗名"
                type="search"
                className={classes.textField}
                margin="normal"
                value={shopName}
                onChange={e => {
                  setShopName(e.target.value);
                }}
              />
              <TextField
                label="来店希望日(from)"
                type="date"
                className={classes.textField}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                value={bookingTimeFrom}
                onChange={e => {
                  setBookingTimeFrom(e.target.value);
                }}
              />
              <TextField
                label="来店希望日(to)"
                type="date"
                className={classes.textField}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                value={bookingTimeTo}
                onChange={e => {
                  setBookingTimeTo(e.target.value);
                }}
              />
            </div>
            <div className={classes.buttonGroupLeft}>
              <SearchButton onClickAction={searchAction} />
            </div>
            <div className={classes.buttonGroupRight}>
              <CsvDownloadButton onClickAction={csvDownloadAction} />
            </div>
          </div>
          {openTable && (
            <ListBookingTable
              page={page}
              handleChangePage={handleChangePage}
              progress={progress}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              setResultMessage={setResultMessage}
              onChangeBookingStatus={onChangeBookingStatus}
              updateOpenProgress={updateOpenProgress}
              updateLoading={updateLoading}
              selectedTicketIds={selectedTicketIds}
              checked={checked}
              setChecked={setChecked}
            />
          )}
        </Paper>
        <ConfirmDialog
          openConfirm={openConfirmDialog}
          updateOpenConfirm={setOpenConfirmDialog}
          message="この社食チケットを未使用に戻しますか。"
          // okAction={() => changeTicketStatus(selectedTicketIds)}
        />
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
        <Modal open={openAcceptPopup}>
          <AcceptPopup
            setOpenAcceptPopup={setOpenAcceptPopup}
            setUpdateOpenAcceptPopup={setUpdateOpenAcceptPopup}
            setDataAccept={selectedBookingIds}
            handleChangePage={handleChangePage}
          />
        </Modal>
        <ProgressDialog
          openProgress={errorMessage !== ''}
          progressOkAction={() => setErrorMessage('')}
          loading={false}
          resultMessage={errorMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
